import { ConversationApi, MessagesApi } from 'api'
import { AxiosPromise } from 'axios'
import { ConversationId, ConversationOpenResponse } from 'types/conversation'
import { Message, MessageRoundTripEventPayload } from 'types/message'

interface GetMessagesForConversationArgs {
  limit?: number,
  conversationId: ConversationId,
  from?: any
}

const MESSAGE_SEND_TIMEOUT = {
  timeout: 15000
}

export const createMessageForNewConversation = (message: Message): AxiosPromise<Message> => {
  return MessagesApi.post<Message>(`/messages`, message, MESSAGE_SEND_TIMEOUT)
}

export const createMessageForExistingConversation = (message: Message): AxiosPromise<Message> => {
  return MessagesApi.post<Message>(`/conversations/${message.conversationId}/messages`, message, MESSAGE_SEND_TIMEOUT)
}

export const createSignedPrerenderedConversation = (signedMessages: Message[], engagedMessage: Message) => {
  return MessagesApi.post(`/messages/signed`, {
    signedMessages,
    engagedMessage
  }, MESSAGE_SEND_TIMEOUT)
}

export const getMessagesForConversation = ({
  limit = 10,
  conversationId,
  from
}: GetMessagesForConversationArgs): AxiosPromise<ConversationOpenResponse<Message[]>> => {
  return MessagesApi.get(`conversations/${conversationId}/messages/page/v2`, { params: { limit, from, withReceipts: true } })
}

export const sendMessageRoundTripTime = (payload: MessageRoundTripEventPayload) => ConversationApi.post(`/stats/widget`, [payload])

